export { Preloader } from './preloader.component';
